// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  GenericApiResponseExportedModule,
  GenericApiResponseStr,
  HTTPValidationError,
  ModuleImportRequest,
} from '../../models';

/**
 * Export a module with all its components (tasks and resources)
 * @summary Export Module
 */
export const exportModule = (
  moduleId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseExportedModule>> => {
  return axios.get(`/modules/${moduleId}/export`, options);
};

export const getExportModuleQueryKey = (moduleId: string) => {
  return [`/modules/${moduleId}/export`] as const;
};

export const getExportModuleQueryOptions = <
  TData = Awaited<ReturnType<typeof exportModule>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportModuleQueryKey(moduleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportModule>>> = ({ signal }) =>
    exportModule(moduleId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!moduleId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportModule>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportModuleQueryResult = NonNullable<Awaited<ReturnType<typeof exportModule>>>;
export type ExportModuleQueryError = AxiosError<HTTPValidationError>;

export function useExportModule<
  TData = Awaited<ReturnType<typeof exportModule>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportModule>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof exportModule>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportModule<
  TData = Awaited<ReturnType<typeof exportModule>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportModule>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof exportModule>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportModule<
  TData = Awaited<ReturnType<typeof exportModule>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export Module
 */

export function useExportModule<
  TData = Awaited<ReturnType<typeof exportModule>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getExportModuleQueryOptions(moduleId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Import a module from export data
 * @summary Import Module
 */
export const importModule = (
  moduleImportRequest: ModuleImportRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseStr>> => {
  return axios.post(`/modules/import`, moduleImportRequest, options);
};

export const getImportModuleMutationOptions = <
  TData = Awaited<ReturnType<typeof importModule>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ModuleImportRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['importModule'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof importModule>>, { data: ModuleImportRequest }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return importModule(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: ModuleImportRequest },
    TContext
  >;
};

export type ImportModuleMutationResult = NonNullable<Awaited<ReturnType<typeof importModule>>>;
export type ImportModuleMutationBody = ModuleImportRequest;
export type ImportModuleMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Import Module
 */
export const useImportModule = <
  TData = Awaited<ReturnType<typeof importModule>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ModuleImportRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: ModuleImportRequest }, TContext> => {
  const mutationOptions = getImportModuleMutationOptions(options);

  return useMutation(mutationOptions);
};
